export default "__VITE_ASSET__DuqWGpmV__"